import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    standalone: false
})
export class FAQComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
